/* TODO: I realize now it would be better to handle the tape as 
	another object, implemented with two stacks, to avoid 
	all the string slicing. */

/* TODO: should have a better way to handle blank cells
 */

class TuringMachine {
  /** A Turing machine consists of a diagram, state,
   *   and tape contents (currently strings) divided into:
   *   contents of the tape left of the head
   *   contents of the cell of tape directly below the head
   *   contents of the tape right of the head
   * The transition diagram (currently, a function), given only
   *   a character and a state, returns:
   *   a character to print
   *   a move instruction (left, right)
   *   a new state to transition into
   */
  constructor(diagram, startState, tapeContents) {
    this.diagram = diagram;
    this.state = startState;
    this.left = "";
    this.head = tapeContents.slice(0, 1);
    this.right = tapeContents.slice(1);
  }
}

Object.defineProperties(TuringMachine.prototype, {
  /** The next instruction is a property of the machine in a
   * given configuration, determined by the current character
   * written by the head, and the current state.
   * By convention, a machine is halted if the next instruction
   * is null.
   */
  nextInstruction: {
    get: function () {
      return this.diagram(this.state, this.head);
    },
  },
  isHalted: {
    get: function () {
      return this.nextInstruction == null;
    },
  },
});

TuringMachine.prototype.step = function () {
  /** Mutates the state of a machine by one
   * step of evolution according to the
   * transition diagram */
  let instruction = this.nextInstruction;
  if (instruction == null || this.isHalted) {
    return false;
  } else {
    this.state = instruction.nextState;
    switch (instruction.nextMove) {
      case "left":
        this.right = String(instruction.printChar) + this.right;
        this.head = this.left.slice(-1);
        this.left = this.left.slice(0, -1);
        break;
      case "right":
        this.left = this.left + String(instruction.printChar);
        this.head = this.right.slice(0, 1);
        this.right = this.right.slice(1);
        break;
      default:
        return false;
    }
    return true;
  }
};

TuringMachine.prototype.toString = function () {
  return `State: {${String(this.state)}} 
   >>${String(this.left)}[${String(this.head)}]${String(this.right)}<< 
   Is halted?: {${String(this.isHalted)}}`;
};

TuringMachine.prototype.dumpConfig = function () {
  return {
    diagram: this.diagram,
    state: this.state,
    left: this.left,
    head: this.head,
    right: this.right,
    halted: this.isHalted,
  };
};

export default TuringMachine;
